export default __webpack_public_path__ + "static/media/item1.713cc7b1.png";